import { AxiosInstance } from 'axios';
import { Dictionary } from 'vuex';

export enum Statuses {
  CHECKED = 'checked',
  ERROR = 'error',
  READY = 'ready',
  WAITING = 'waiting',
}

export interface HavingId {
  id: string | number;
  name: string;
}

export interface Item {
  date: Date;
  count: number;
}

export interface Sections {
  section: string;
  subSection: string;
}

export interface Params extends Sections {
  year: string;
  month: string;
}

export interface FetchParams extends Sections {
  year: number;
  month: number;
}

export interface Providers {
  $api: AxiosInstance;
  $config: Dictionary<any>;
}

export interface State extends FetchParams {
  items: Items;
  status: Statuses;
}

export interface Text {
  text: string;
  title: string;
  value: any;
}

export type Items = Array<Item>;
export type Url = string;



// WEBPACK FOOTER //
// ./src/pages/activities/calendar/types.ts